import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import CircularProgress from '@material-ui/core/CircularProgress';
import { setupI18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import catalogEn from './locale/en/messages';
import catalogFr from './locale/fr/messages';
import Store from './components/Store';
import CommitProcess from './components/CommitProcess';
// import testHappening from './testHappening';

export const i18n = setupI18n({ catalogs: { en: catalogEn, fr: catalogFr } });

const App = () => {
  let theme = createMuiTheme({
    spacing: 8,
    typography: {
      fontFamily: ['gibson']
    },
    shape: {
      borderRadius: 3
    },
    palette: {
      primary: {
        main: '#1e4955'
      },
      secondary: {
        main: '#e53e51'
      }
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    green: '#b4bd00',
    pink: '#e53e51',
    blue: '#1e4955',
    deepBlue: '#183a44'
  });

  theme.stepTitle = {
    marginTop: 32,
    marginBottom: 8,
    [theme.breakpoints.up('xs')]: {
      fontSize: 16
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 18
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 22
    }
  };

  theme = responsiveFontSizes(theme);

  const [happening, setHappening] = useState(null);
  const [lang, setLang] = useState('');

  //DEBUG
  // window._siteUrl = 'http://home.beve.org';
  // window._hid = 5470;
  // window._exists = true;
  // window._cids = [955, 941]; // soda et fourneaux
  // window._cids = '';

  useEffect(() => {
    if (!window._hid) {
      console.error('No event id provided to display online commitment');
      return;
    }

    // Get happening informations
    axios
      .get(`/wp-json/coolfood/v1/online_happening/${window._hid}`)
      .then(response => {
        setHappening(response.data);
        if (
          response.data.happening.lang &&
          response.data.happening.lang.match(/[a-z]{2}_[A-Z]{2}/)
        ) {
          const l = response.data.happening.lang.split('_')[0];
          i18n.activate(l);
          setLang(l);
        }
      });
  }, [lang]);

  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Store>
          <I18nProvider
            catalogs={{ en: catalogEn, fr: catalogFr }}
            language="fr"
            defaultRender={<div />}
          >
            <div className="App">
              {!lang === '' ||
              !happening ||
              (happening && !happening.commitments) ? (
                  <div style={{ marginTop: 40, marginBottom: 40, textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                ) : (
                  <CommitProcess happening={happening} lang={lang} />
                )}
            </div>
          </I18nProvider>
        </Store>
      </ThemeProvider>
    </>
  );
};

export default App;
